<template>
    <div>
        <OwnerTransactionList/>
    </div>
</template>

<script>
import OwnerTransactionList from '../../../components/tax/TaxInquiry/OwnerSearch/OwnerTransactionList.vue';

export default {
  name: 'OwnerSearch',
  data: () => ({

  }),
  components: {
    OwnerTransactionList,
  },
};
</script>
